// extracted by mini-css-extract-plugin
module.exports = {"footer":"AuthFooter_footer__3eLQY","footerL":"AuthFooter_footerL__2IBgN","footerRes":"AuthFooter_footerRes__3ldXV","footerNone":"AuthFooter_footerNone__3Qf_H"};